import { useTranslation } from "react-i18next";

export default function useLogin() {
  const { i18n } = useTranslation();

  return () =>
    (window.location.href = `${process.env.REACT_APP_LOGIN_URL}&lang=${i18n.language}`);
}
